<main>

  <section>
    <div class="actions">
      <h1>Liste des utilisateurs</h1>
      <button  class="card-button" mat-flat-button color="accent" (click)="createSubUsers()">{{'userCreation' | translation}}</button>
    </div>
    <div class="listUserContainer">

      <ng-container *ngIf="listUsers && listUsers.length == 0">
        <ng-container *ngIf="!noUser">
          <mat-spinner></mat-spinner>
        </ng-container>
        <ng-container *ngIf="noUser">
          <h1>Aucun utilisateur</h1>
        </ng-container>

      </ng-container>


      <ng-container *ngIf="listUsers && listUsers.length > 0">
        <mat-card *ngFor="let user of listUsers">
          <mat-card-header>
            <mat-card-title>{{user.data.email}}</mat-card-title>
            <mat-card-subtitle>Crée le {{user.data.createdAt.seconds*1000 | date: 'dd MMMM yyyy'}}</mat-card-subtitle>
          </mat-card-header>
          
          <mat-card-content>




            <mat-form-field>
              <mat-label>{{'selectDeviceToBind' | translation}}</mat-label>
              <mat-select disableRipple [ngModel]="user.data.assignedDevice" (ngModelChange)="onDeviceChange(user, $event)">
                <mat-option *ngFor="let device of listDevices" [value]="device.id">{{device.data.name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <div>
    <p><strong>ID:</strong> {{user.id}}</p>
  </div><div>
    <p><strong>Email:</strong> {{user.data.email}}</p>
    <button class="card-button" mat-flat-button color="accent" (click)="updateEmailPopUp(user.data.email)">{{'updateEmail' | translation}}</button>
  </div>
  <div>
    <p><strong>Date de création:</strong> {{user.data.createdAt.seconds*1000 | date: 'dd MMMM yyyy HH:mm'}}</p>
  </div>
  <div>
    <button mat-flat-button color="warn" *ngIf="user.role != 'mainuser'" (click)="deleteUser(user.id)"><mat-icon>delete</mat-icon></button>
  </div> -->
          </mat-card-content>

          <mat-card-actions>
            <!-- {{'updateEmail' | translation}} -->
            <button class="card-button" mat-mini-fab color="accent" (click)="updateEmailPopUp(user.data.email)"><mat-icon>edit</mat-icon></button>
            <button mat-mini-fab color="warn" *ngIf="user.role != 'mainuser'" (click)="deleteUser(user.id)"><mat-icon>delete</mat-icon></button>
          </mat-card-actions>
        </mat-card>
      </ng-container>

    </div>

  </section>

</main>

